import ExtensionInstance from 'automation-ui-action-features/actions/extension/ExtensionInstance';
import GenericActionField from 'automation-ui-action-features/actions/extension/generic-extension/GenericActionField';
import { fieldDefinitionToMetadataField } from 'automation-ui-action-features/actions/extension/generic-extension/fieldDefinitionToMetadataField';
import { convertFieldValueToPropertyValue } from 'automation-ui-action-features/actions/extension/utils/convertFieldValueToPropertyValue';
import { convertPropertyValueToFieldValue } from 'automation-ui-action-features/actions/extension/utils/convertPropertyValueToFieldValue';
import { getDefinitionIdFromActionTypeId } from 'automation-ui-action-features/actions/extension/utils/getDefinitionIdFromActionTypeId';
import { Map as ImmutableMap, Record } from 'immutable';
const defaultVersion = 1;
const transformFields = fields => fields.map(field => ({
  fieldKey: field.fieldKey || '',
  // Can this be null?
  fieldValue: convertFieldValueToPropertyValue(field.fieldValue),
  inputActionName: field.inputActionName
}));

/**
 * TODO AM: remove objects -> strings property change once isRequired flag
 * removed from BE
 */
const transformProperties = (properties = []) => properties.map(option => typeof option !== 'string' && 'propertyName' in option ? option.propertyName : option);
export default class ExtensionActionMetadata extends Record({
  actionType: 'AUTOMATION_EXTENSION',
  actionTypeId: undefined,
  extensionInstance: null,
  extensionInstanceId: null,
  extensionInstanceVersion: null,
  inputValueFields: [],
  objectRequestOptions: null
}, 'ExtensionActionMetadata') {
  constructor(props, definition = {}) {
    var _instance$objectReque, _props$objectRequestO;
    // NOTE(bheng): Instance data takes precedence over definition data.
    const instance = props === null || props === void 0 ? void 0 : props.extensionInstance;
    const actionTypeId = (instance === null || instance === void 0 ? void 0 : instance.actionTypeId) || (props === null || props === void 0 ? void 0 : props.actionTypeId) || definition.actionTypeId;
    const extensionDefinitionId = (instance === null || instance === void 0 ? void 0 : instance.extensionDefinitionId) || actionTypeId && getDefinitionIdFromActionTypeId(actionTypeId) || undefined;
    const extensionDefinitionVersion = (instance === null || instance === void 0 ? void 0 : instance.extensionDefinitionVersion) || defaultVersion;
    // if user deletes value, BE deletes entire field. so, assume user meant to leave field blank
    const isExistingExtensionInstance = !!(instance !== null && instance !== void 0 && instance.fields.length);
    const fields = (instance === null || instance === void 0 ? void 0 : instance.fields) ||
    // Not guaranteed to be GenericActionField[]
    (definition.inputFields || []).map(field => fieldDefinitionToMetadataField({
      fieldDefinition: field,
      ignoreDefaultValue: isExistingExtensionInstance
    }));
    /**
     * NOTE(bheng): Because of how these Immutable Records are typed, it's not
     * actually guaranteed that `instance.fields` is an array of
     * `GenericActionField`. This has caused a critsit.
     */
    const fieldRecords = fields.map(field => new GenericActionField(field));
    // instance.fields is the source of truth for inputValueFields for now.
    const inputValueFields = transformFields(fieldRecords);
    const objectRequestOptions = {
      properties: transformProperties((instance === null || instance === void 0 || (_instance$objectReque = instance.objectRequestOptions) === null || _instance$objectReque === void 0 ? void 0 : _instance$objectReque.properties) || (props === null || props === void 0 || (_props$objectRequestO = props.objectRequestOptions) === null || _props$objectRequestO === void 0 ? void 0 : _props$objectRequestO.properties))
    };
    super(ImmutableMap(props).set('extensionInstance', new ExtensionInstance({
      actionTypeId,
      extensionDefinitionId,
      extensionDefinitionVersion,
      fields: fieldRecords,
      objectRequestOptions
    })).set('actionTypeId', actionTypeId).set('inputValueFields', inputValueFields).set('objectRequestOptions', objectRequestOptions));
  }
  getActionTypeId() {
    return this.actionTypeId || null;
  }
  getExtensionDefinitionVersion() {
    var _this$extensionInstan;
    return ((_this$extensionInstan = this.extensionInstance) === null || _this$extensionInstan === void 0 ? void 0 : _this$extensionInstan.extensionDefinitionVersion) || null;
  }

  /**
   * @deprecated Prefer `getInputValueFields`
   */
  getFields() {
    var _this$inputValueField, _this$extensionInstan2;
    if ((_this$inputValueField = this.inputValueFields) !== null && _this$inputValueField !== void 0 && _this$inputValueField.length) {
      return this.inputValueFields.map(field => new GenericActionField(Object.assign({}, field, {
        fieldValue: convertPropertyValueToFieldValue(field.fieldValue)
      })));
    }
    return ((_this$extensionInstan2 = this.extensionInstance) === null || _this$extensionInstan2 === void 0 ? void 0 : _this$extensionInstan2.fields) || [];
  }
  getInputValueFields() {
    return this.inputValueFields || [];
  }
  getObjectRequestOptions() {
    return this.objectRequestOptions || {
      properties: []
    };
  }
  getObjectRequestOptionsProperties() {
    var _this$objectRequestOp;
    return ((_this$objectRequestOp = this.objectRequestOptions) === null || _this$objectRequestOp === void 0 ? void 0 : _this$objectRequestOp.properties) || [];
  }

  /**
   * Overrides all existing fields
   * @deprecated Prefer `setInputValueFields`
   */
  setFields(fields) {
    return this.set('extensionInstance', this.extensionInstance ? this.extensionInstance.setFields(fields) : new ExtensionInstance({
      fields
    })).set('inputValueFields', transformFields(fields));
  }
  setInputValueFields(inputValueFields) {
    const fields = inputValueFields.map(field => {
      return new GenericActionField(Object.assign({}, field, {
        fieldValue: convertPropertyValueToFieldValue(field.fieldValue)
      }));
    });
    return this.set('extensionInstance', this.extensionInstance ? this.extensionInstance.setFields(fields) : new ExtensionInstance({
      fields
    })).set('inputValueFields', inputValueFields);
  }
  setObjectRequestOptions(objectRequestOptions) {
    const properties = transformProperties(objectRequestOptions.properties);
    return this.set('extensionInstance', this.extensionInstance ? this.extensionInstance.setObjectRequestOptions({
      properties
    }) : new ExtensionInstance({
      objectRequestOptions: {
        properties
      }
    })).set('objectRequestOptions', {
      properties
    });
  }
  setObjectRequestOptionsProperties(properties) {
    return this.setObjectRequestOptions({
      properties
    });
  }
}